/**
 * The documents data api.
 */
export default class Documents {
    /**
     * Create by option.
     * @param option - such as api manager or  security manager.
     */
    constructor(option) {
        this.apiManager = option.apiManager;
    }
    /**
     * get regulatory filings document list
     * @param params - the request parameter, can use performance id
     */
    regulatoryFilings(params) {
        const performanceIds =
            typeof params.performanceIds === 'string'
                ? params.performanceIds
                : params.performanceIds.join(',');
        const skip = params.skip || 0;
        const limit = params.limit || 50;
        return this.apiManager.getRegulatoryFilings({
            performanceIds,
            skip,
            limit
        });
    }
}
